import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { ArrowRight, BarChart3 } from 'lucide-react';
export function Research() {
  const themes = ['Access to capital and funding pathways', 'Effectiveness of founder programming', 'Operational barriers to scale', 'Measurable business outcomes', 'AI readiness and workforce advancement', 'Leadership sustainability and burnout'];
  return <section id="research" className="py-24 lg:py-40 bg-warm-sand-light relative overflow-hidden" data-id="element-237">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-vivid-orange/30 to-transparent" data-id="element-238"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-239">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-240">
          <div data-id="element-241">
            <FadeIn data-id="element-242">
              <p className="text-[11px] font-semibold tracking-[0.4em] uppercase text-vivid-orange mb-8" data-id="element-243">
                Research & Ecosystem Intelligence
              </p>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-medium leading-[1.05] text-deep-azure mb-8" data-id="element-244">
                The State of Women-Led{' '}
                <em className="italic font-light text-dark-azure" data-id="element-245">
                  Business Growth
                </em>{' '}
                in Ontario.
              </h2>
              <p className="text-lg text-charcoal-navy/75 leading-relaxed mb-10 font-light" data-id="element-246">
                LeadHERship Equity is launching a research initiative focused on
                understanding the real experiences, barriers, and growth
                opportunities impacting women founders across Ontario.
              </p>

              <a href="#cta" className="inline-flex items-center gap-2 bg-vivid-orange hover:bg-vivid-orange-light text-white font-medium text-sm tracking-[0.05em] uppercase py-4 px-8 rounded-sm transition-all duration-300 group" data-id="element-247">
                Participate in the Study
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-248" />
              </a>
            </FadeIn>
          </div>

          <div data-id="element-249">
            <FadeIn delay={0.2} direction="left" data-id="element-250">
              {/* Editorial research card */}
              <div className="bg-white border border-warm-sand-dark/40 p-10 lg:p-12 shadow-[0_30px_60px_-30px_rgba(8,35,77,0.2)]" data-id="element-251">
                <div className="flex items-center gap-3 mb-8 pb-6 border-b border-warm-sand-dark/40" data-id="element-252">
                  <div className="w-10 h-10 bg-deep-azure flex items-center justify-center" data-id="element-253">
                    <BarChart3 className="w-5 h-5 text-golden-yellow" data-id="element-254" />
                  </div>
                  <div data-id="element-255">
                    <p className="text-[10px] uppercase tracking-[0.2em] text-vivid-orange font-semibold" data-id="element-256">
                      Research Initiative
                    </p>
                    <p className="text-sm font-display italic text-deep-azure" data-id="element-257">
                      Ontario · 2025
                    </p>
                  </div>
                </div>

                <h3 className="text-xs font-semibold tracking-[0.2em] uppercase text-deep-azure mb-6" data-id="element-258">
                  Core Research Themes
                </h3>
                <StaggerContainer className="space-y-5" data-id="element-259">
                  {themes.map((theme, index) => <StaggerItem key={index} className="flex items-start gap-4" data-id="element-260">
                      <span className="text-xs font-display italic text-golden-yellow font-semibold mt-1 flex-shrink-0 w-6" data-id="element-261">
                        0{index + 1}
                      </span>
                      <span className="text-charcoal-navy/80 leading-relaxed text-base" data-id="element-262">
                        {theme}
                      </span>
                    </StaggerItem>)}
                </StaggerContainer>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}